import React, { useState } from 'react'

import { useKeyMetricActions } from 'redux/actions/KeyMetrics'
import { useKeyMetric } from 'redux/hooks/KeyMetrics'
import { useTranslation } from 'language/translator'
import { useParams } from 'utils/hooks'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'

import EditWrapper from 'components_new/molecules/EditWrapper'

import MetricEditBody from 'components_new/organisms/MetricEditBody'
import MetricEditSidebar from 'components_new/organisms/MetricEditSidebar'

import KeyMetricTemplate from 'components_new/templates/KeyMetricTemplate'

import { useMetricEdit } from 'components_new/organisms/dialogs/MetricEditDialog/utils'
import { getResourceVariant } from 'types/GlobalKeyMetric'

const KeyMetricSettings = () => {
  const { id } = useParams<{ id: string }>()
  const keyMetric = useKeyMetric(id)
  const { tryUpdateKeyMetric } = useKeyMetricActions()
  const { t } = useTranslation()

  const [edit, setEdit] = useState<boolean>(false)

  const {
    editKeyMetric,
    editMetric,
    handleDistributionChange,
    handleMetricChange,
    handleRollingSumChange,
    handleSlicesChange,
    reset,
    updateKeyMetric
  } = useMetricEdit({ keyMetric, metric: keyMetric?.metric ?? null })

  const handleSave = () => {
    if (!keyMetric || !editKeyMetric) return

    tryUpdateKeyMetric(keyMetric.id, {
      group_ids: editKeyMetric.groups.map((g) => g.id),
      kpi_template_id: editMetric.id,
      resources: editKeyMetric.resources.map((r) => ({
        id: r.id,
        type: getResourceVariant(r)
      })),
      responsible_account_id: editKeyMetric.responsible_account_id,
      ...editMetric.settings,
      target_activated: editKeyMetric.target_activated,
      target_value: editKeyMetric.target_value,
      title: editKeyMetric.title,
      increase_is_positive: editKeyMetric.increase_is_positive
    })
  }

  const handleClickEdit = () => {
    if (edit) {
      handleSave()
    }
    setEdit(!edit)
  }

  const handleClickCancel = () => {
    reset()
    setEdit(false)
  }

  return (
    <KeyMetricTemplate
      subpage={{ icon: { name: 'Settings' }, title: t('global', 'settings') }}
      topbar={{
        actions: (
          <>
            {edit ? (
              <Button onClick={handleClickCancel} variant="text">
                {t('global', 'cancel')}
              </Button>
            ) : null}
            <Button
              onClick={handleClickEdit}
              variant={edit ? 'contained' : 'text'}
            >
              {t('global', edit ? 'save' : 'edit')}
            </Button>
          </>
        )
      }}
      variant="feed"
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <EditWrapper edit={edit} sx={{ flex: 2, p: 2 }}>
          <MetricEditBody
            editKeyMetric={editKeyMetric}
            editMetric={editMetric}
            onDistributionChange={handleDistributionChange}
            onKeyMetricChange={updateKeyMetric}
            onMetricChange={handleMetricChange}
            onRollingSumChange={handleRollingSumChange}
            onSlicesChange={handleSlicesChange}
          />
        </EditWrapper>

        <EditWrapper edit={edit} sx={{ flex: 1, p: 2 }}>
          <MetricEditSidebar
            editKeyMetric={editKeyMetric}
            onKeyMetricChange={updateKeyMetric}
          />
        </EditWrapper>
      </Box>
    </KeyMetricTemplate>
  )
}

export default KeyMetricSettings
